import { Col, Row } from "react-bootstrap"
import { SimplifiedSingleNews } from "../../../types/news"
import React from "react"
import { removeLinkRelNoopenerNoreferrer } from "../../../utils/urls"
import calendar from "@assets/images/calendar.png"
import moment from "moment"
import style from "./PredictionNewsContent.module.scss"
import Image from "next/image"
import * as ImageConstants from "../../../constants/images"
import Link from "next/link"

export const PredictionNewsContent = ({ news, trigger }: { news: SimplifiedSingleNews; trigger?: string | null }) => {
  const authorTitle = news.authors && news.authors.length > 1 ? "Autori: " : "Autore: "
  return (
    <Col className={style.predictionNewsContent}>
      <h1 className={style.title + " pageTitle"}>{news.title}</h1>
      <Row>
        <Col xl={6} lg={6} md={6} xs={12}>
          Pubblicato il: {moment(news.publishedAt).format("DD/MM/YYYY")}
        </Col>
        <Col xl={6} lg={6} md={6} xs={12}>
          {news.authors && (
            <>
              {authorTitle}
              {news.authors.map((a) => {
                return (
                  <Link key={a.id} href={`/autori/${a.author?.calciocomSlug}`}>
                    {a.author?.name}
                  </Link>
                )
              })}
            </>
          )}
        </Col>
      </Row>
      <div className={style.whiteBgHolder} />
      <div className={style.newsBanner}>
        {/* <div className={style.competitionBanner}>
          <Link href={"https://bit.ly/go-planetwin365-news"} passHref>
            <a target={"_blank"}>
              <div className={style.img}>
                <span>By</span>
                <Image src={banner} width={160} height={34} alt="planetwin" />
              </div>
            </a>
          </Link>
        </div> */}
        <div className={style.matchDate}>
          <Image src={calendar} width={20} height={22} alt="calendario" />
          <span className={style.date}>{moment(news.predictionMatch?.date).format("DD/MM/YYYY")}</span>
        </div>
        <div className={style.bannerContent}>
          <div className={style.mobileViewContainer}>
            <Col xs={4} sm={4} md={4} className={style.mobileViewTeam}>
              <div className={style.image}>
                {news.predictionMatch?.homeTeam?.image?.path && (
                  <Image
                    blurDataURL={ImageConstants.TEAM_MISSING_IMAGE_PATH}
                    placeholder="blur"
                    src={news.predictionMatch?.homeTeam?.image?.path}
                    width={60}
                    height={60}
                    alt="home team"
                  />
                )}
              </div>
              <div className={style.name}>{news.predictionMatch?.homeTeam?.name}</div>
            </Col>
            <Col className={style.vs} md={2}>
              <span>VS</span>
            </Col>
            <Col xs={4} sm={4} md={4} className={style.mobileViewTeam}>
              <div className={style.image}>
                {news.predictionMatch?.awayTeam?.image?.path && (
                  <Image
                    blurDataURL={ImageConstants.TEAM_MISSING_IMAGE_PATH}
                    placeholder="blur"
                    src={news.predictionMatch?.awayTeam?.image?.path}
                    width={60}
                    height={60}
                    alt="away team"
                  />
                )}
              </div>
              <div className={style.name}>{news.predictionMatch?.awayTeam?.name}</div>
            </Col>
          </div>
          <Col lg={3} className={style.team}>
            <div className={style.image}>
              {news.predictionMatch?.homeTeam?.image?.path && (
                <Image
                  blurDataURL={ImageConstants.TEAM_MISSING_IMAGE_PATH}
                  placeholder="blur"
                  src={news.predictionMatch?.homeTeam?.image?.path}
                  width={60}
                  height={60}
                  alt="home team"
                />
              )}
            </div>
            <div className={style.name}>{news.predictionMatch?.homeTeam?.name}</div>
          </Col>
          {/*<Col md={12} lg={6} className={style.trigger}>*/}
          {/*  <PredictionQuotes roundBorders={false} color="yellow" col={12} news={news} />*/}
          {/*</Col>*/}
          <Col lg={3} className={style.team}>
            <div className={style.image}>
              {news.predictionMatch?.awayTeam?.image?.path && (
                <Image
                  blurDataURL={ImageConstants.TEAM_MISSING_IMAGE_PATH}
                  placeholder="blur"
                  src={news.predictionMatch?.awayTeam?.image?.path}
                  width={50}
                  height={50}
                  alt="away team"
                />
              )}
            </div>
            <div className={style.name}>{news.predictionMatch?.awayTeam?.name}</div>
          </Col>
        </div>
      </div>
      <div className={style.content}>
        <h2 className={style.subtitle}>{news.subtitle}</h2>
        <div
          dangerouslySetInnerHTML={{
            __html: removeLinkRelNoopenerNoreferrer(
              news.content.replace("\n", "<br/><br/>").replace(/triggerIframeQuote/g, ""),
            ),
          }}
        />
      </div>
    </Col>
  )
}
